import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface CoachingSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Coaching"}}
  {{outlet}}
</template> satisfies TOC<CoachingSignature>;
